export function backToFirstPage(state, payload) {
    return {
        ...state,
        currentIndex: 0,
        progressIndex: 0
    };
};